import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { isNativeAndroid } from "../lib/billing";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(async () => {
        try {
          await api.post("/auth/refresh");
          const r = await api.get("/auth/me");
          setUser(r.data);
        } catch {
          setUser(null);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password, platform: isNativeAndroid() ? "app" : "web" });
    setUser(data);
    return data;
  };

  const register = async (name, email, password, birthDate, ageConfirmed, gender) => {
    const { data } = await api.post("/auth/register", { name, email, password, birth_date: birthDate, age_confirmed: ageConfirmed, gender, platform: isNativeAndroid() ? "app" : "web" });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    setUser(null);
  };

  const refresh = async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch { /* ignore */ }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
